"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDestinationActionService = isDestinationActionService;
function isDestinationActionService() {
    return (process.env.DESTINATIONS_ACTION_SERVICE === 'true' || process.env.SERVICE_NAME === 'destination-actions-service');
}
//# sourceMappingURL=isDestinationActionService.js.map